export interface RequestCancelBookingInterface {
  bookingInternalNo: string;
  reason: string;
  cToken?: string;
}
export class ResponseCancelBookingPresenter {
  status: boolean;

  message: string;

  statusCode: string;

  constructor(data: any) {
    this.status = data?.status || false;
    this.message = data?.message || "";
    this.statusCode = data?.statusCode || "";
  }
}
